import { Div } from '@codesuma/baseline'
import { Page } from '../../components/page'
import { BackIcon } from '../../components/back-icon'
// Every release bumps the root package.json on web, Android and iOS alike, so its
// version is the one to show. Rollup inlines just this field, not the whole file.
import { version } from '../../../package.json'
import style from './index.module.css'

// Plain answers to what a first-time user wonders about.
const POINTS = [
    ['Share with anyone', 'Open a list and tap the share button. Everyone on the list sees changes right away.'],
    ['Works without internet', 'Your lists are saved on your phone. Changes sync when you are back online.'],
    ['No sign-up needed', 'Start right away. Signing in is optional. It keeps your lists when you change phones.'],
]

export const AboutPage = () => {
    // Page() gives the shared slide transition (enter from bottom, exit up;
    // reversed on back). Override its background with the themed page tokens (these
    // are CSS vars, so the page follows light/dark live — even while cached).
    const base = Page()
    base.style({ background: 'var(--page-bg)', color: 'var(--page-fg)' })

    // currentColor so it picks up the dark page foreground.
    const back = BackIcon('currentColor')
    base.append(back)

    // The page shell doesn't scroll, and a large OS text size can make this taller
    // than the screen.
    const scroller = Div()
    scroller.addClass(style.scroller)

    const icon = Div()
    icon.addClass(style.icon)

    const name = Div('Papa List')
    name.addClass(style.name)

    const versionLabel = Div(`Version ${version}`)
    versionLabel.addClass(style.version)

    const description = Div('A simple, shared list for anything — shopping, packing, travel, and more.')
    description.addClass(style.description)

    scroller.append(icon, name, versionLabel, description)

    for (const [title, text] of POINTS) {
        const point = Div()
        point.addClass(style.point)
        const pointTitle = Div(title)
        pointTitle.addClass(style.pointTitle)
        const pointText = Div(text)
        pointText.addClass(style.pointText)
        point.append(pointTitle, pointText)
        scroller.append(point)
    }

    const credit = Div('Made by Codesuma')
    credit.addClass(style.credit)
    scroller.append(credit)

    base.append(scroller)
    return base
}
